import { render, staticRenderFns } from "./KioskArrivalStatus.vue?vue&type=template&id=396191e6&scoped=true&"
import script from "./KioskArrivalStatus.vue?vue&type=script&lang=js&"
export * from "./KioskArrivalStatus.vue?vue&type=script&lang=js&"
import style0 from "./KioskArrivalStatus.vue?vue&type=style&index=0&id=396191e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396191e6",
  null
  
)

component.options.__file = "KioskArrivalStatus.vue"
export default component.exports